// extracted by mini-css-extract-plugin
module.exports = {"bubble":"styles__bubble___2Rc6H"};